/** @jsxImportSource theme-ui */
import { Button } from "components";
import * as styles from "./LearnMore.styles";

export default function LearnMore({ children, ...props }) {
  return (
    <Button variant="unstyled" sx={styles.learnMoreButton} {...props}>
      {children}
    </Button>
  );
}
